import { adminRequest } from '@/shared/request-configs/admin-request';

/**
 * Fetches Auto Responder by client id <br>
 * API Endpoint - `/outbound-notifications-service/auto_responder/${clientId}` <br> via {@link adminRequest.get}
 * @param {number} clientId - id of the client
 */
export const get = async (clientId: number) => adminRequest.get(
  `/outbound-notifications-service/auto_responder/${clientId}`,
);
/**
 * Sends Auto Responder Outbound Notification <br>
 * API Endpoint - `/outbound-notifications-service/test_auto_responder/${payload.clientId}` <br> via {@link adminRequest.post}
 * @param payload - auto responder to send
 */
export const send = async (payload: any) => adminRequest.post(`/outbound-notifications-service/test_auto_responder/${payload.clientId}`, payload);
/**
 * Creates | Updates Auto Responders <br>
 * API Endpoints:
 * <li>`/outbound-notifications-service/auto_responder/${payload.clientId}/${payload.id}` <br> via {@link adminRequest.put}</li>
 * <li>`/outbound-notifications-service/auto_responder/${payload.clientId}` <br> via {@link adminRequest.post}</li>
 * @param payload - auto responder to create | update
 */
export const post = async (payload: any) => {
  if (payload.id) {
    return adminRequest.put(`/outbound-notifications-service/auto_responder/${payload.clientId}/${payload.id}`, payload);
  }

  return adminRequest.post(`/outbound-notifications-service/auto_responder/${payload.clientId}`, payload);
};
/**
 * Fetches Categories <br>
 * API Endpoint - `/outbound-notifications-service/interpolated_fields/${clientId}` <br> via {@link adminRequest.get}
 * @param clientId - id of the client to fetch categories for
 */
export const getCategories = async (clientId: number) => adminRequest.get(
  `/outbound-notifications-service/interpolated_fields/${clientId}`,
);

export default {
  get,
  post,
  send,
  getCategories,
};
